<template>
<div>
    <header class="qb-padding qb-gradient-2 qb-shadow">
        <a @click="hide()" class="main-modal-close" style="">
            <close class="md-28"/>
        </a>
        <h2>Adicionar Produto</h2>
    </header>
    <div class="p-modal qb-padding">
        <!-- topo -->        
        <div class="modal-left qb-container">            
            <div class="qb-margin-left margin-left qb-main-body-card">
                <h3 class="title">{{description}}<span class="codigo-produto"> referência # {{id}}</span></h3>        
                <div>
                   <ul class="qb-txt-md  margin-left" style="list-style: circle; line-height: 2em;">
                       <li>Marca: {{ brand }}</li>
                       <li>Classificação: {{ classificationDescription }}</li>
                       <li>Estoque: {{ stock }}</li>
                   </ul>
                </div>      
                 <div class="prices">
                    <p v-if="unitaryPrice != discountPrice" class="desconto qb-txt-md">{{ priceFormater(unitaryPrice) }}</p>
                    <p v-if="unitaryPrice != discountPrice" class="qb-txt-sm">{{ percentageDiscount }}%</p>
                    <p class="final qb-txt-lg margin-left" v-if="discountPrice">{{ priceFormater(discountPrice) }}</p>
                </div>
                <div>
                    <p class="qb-txt-xs" style="font-weight: 700;">Preço Sugerido: {{ priceFormater(  parseInt(unitaryPrice + (unitaryPrice * ( ( !suggestionPrice || suggestionPrice == '' || suggestionPrice == 0 ? 20 : suggestionPrice) / 100))) +1 ) }}</p>
                </div>
                <div v-if="specification">
                    <p>Especificação:</p>
                    <p>{{specification}}</p>
                    <!--<badger-accordion>
                        <badger-accordion-item>
                            <template slot="header">Especificação</template>    
                            <template slot="content">{{ specification }}</template>  
                        </badger-accordion-item>
                    </badger-accordion>-->
                </div>
                <div style="display: flex; justify-content: center;">
                    <!--<a v-if="urlDetail" :href="ajustaURL()" target="_blank">mais detalhes <OpenInNew /></a>-->
                    <a v-if="urlDetail" @click="openTab" target="_blank">mais detalhes <OpenInNew /></a>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="image" style="max-width: 80px;max-height: 100%;min-height: 80px;">
                <carousel :autoplay="false" :nav="false" :items="1" v-if="images.length">
                    <img v-for="(imagem, index) in images" :key="index" :src="imagem" @click="show()" alt="foto produto" style="max-width: 80px;height: auto;min-height: 80px;"/>
                </carousel>
                <img v-else src="@/assets/sem-foto.png" alt="foto produto" style="max-width: 80px;max-height: 80px;min-height: 80px;"/>
            </div>
            <div v-if="stock > 0" class="p-quantity">
                <div class="btn-quantity">
                    <MinusBox @click="subtrai" class="md-28 qb-txt-color-3" />
                </div>
                <div class="input-quantity">
                    <input type="number" :value="quantity" min="1" :max="stock" @keyup="inputAlterado">
                </div>
                <div class="btn-quantity">
                    <PlusBox @click="incrementa" class="md-28 qb-txt-color-3"/>
                </div>
            </div>
            <div class="btn-confirma qb-margin-top">
                <button v-if="stock > 0" class="btn btn-primary qb-txt-lg btn-full" @click="confirma()">Add {{ subTotal }}</button>
                <button v-if="stock <= 0" class="btn btn-primary qb-txt-lg btn-full indisponivel" disabled>Indisponível</button>
                <p v-if="stock <= 0 && dataPrevista != '01/01/0001'"> Previsão: {{dataPrevista}}</p>
            </div>
        </div>
    </div>
    <footer v-show="false" class="qb-padding qb-gradient-1">        
    </footer>

    <modal key="foto" name="foto" :adaptive="true" height="auto" :resizable="true" :scrollable="true"  >
        <div style="display: flex;align-items: center;justify-content: space-between;margin: 0 16px; ">
        <div>
            <p style="font-weight: 100;font-size: 16px;">Produto # {{ id }} - {{description}}</p>
        </div>
        <div>
            <a @click="$modal.hide('foto')" style="">
                <close class="md-28"/>
            </a>
        </div>
        </div>
        <carousel :autoplay="false" :nav="false" :items="1">
            <img v-for="(imagem, index) in images" :key="index" :src="imagem" alt="foto produto" style="max-width: 100%;"/>
        </carousel>
    </modal>
</div>
</template>

<script>
import axios from "axios";
import { baseApiUrl, userKey, baseImage } from "@/global";
import PlusBox from "vue-material-design-icons/PlusBox.vue";
import MinusBox from "vue-material-design-icons/MinusBox.vue";
import Close from "vue-material-design-icons/Close.vue";
import OpenInNew from "vue-material-design-icons/OpenInNew.vue";
import carousel from 'vue-owl-carousel';
//import {BadgerAccordion, BadgerAccordionItem} from 'vue-badger-accordion'

export default {
    components:{
        PlusBox,
        MinusBox,
        OpenInNew,
        carousel,
        Close,
        //BadgerAccordion,
        //BadgerAccordionItem
    },
    props:['id', 'description', 'brand' ,'classificationId', 'classificationDescription', 'unitaryPrice', 'specification', 'images', 'idModal', 'discountPrice', 'percentageDiscount', 'urlDetail', 'stock', 'suggestionPrice', 'dataPrevista'],
     data(){
        return{
           quantity: 1,
           baseImage: baseImage
        }
    }, 
    computed:{
         subTotal(){
             let resultado;
             if(this.discountPrice != null){
                resultado = this.discountPrice * this.quantity;     
             } else {
                resultado = this.unitaryPrice * this.quantity;
             }
            return resultado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }
    },
    methods:{
        hide () {
            this.quantity = 1;
            this.$modal.hide(this.idModal);
        },
        show(){
            this.$modal.show('foto');
        },
        incrementa(){
            this.quantity++;
        },
        subtrai(){
            if(this.quantity == 1) return
            this.quantity--;
        },
        confirma(){
            this.$modal.hide(this.idModal);
            const json = localStorage.getItem(userKey);
            const userData = JSON.parse(json);
            const json2 = localStorage.getItem('vendedor');
            const vendedor = JSON.parse(json2);
            
            let prod = {
                productId: this.id,
                orderId: userData.orderId,
                description: this.description,
                quantity: this.quantity,
            };

            var data ={
                header: {"Access-Control-Allow-Origin": "true"}
            }
 

            
            if(userData.typeAccess == "V" && vendedor.typeAccess == "V")
            {   
                // Recuperando o item do localStorage
                let clienteUsuarioVinculado = localStorage.getItem('cliente_usuario_vinculado');
                
                if (clienteUsuarioVinculado) {
                    // Convertendo a string JSON de volta para um objeto
                    clienteUsuarioVinculado = JSON.parse(clienteUsuarioVinculado);
                    
                    // Exibindo apenas o ID no console
                    var idClientUser = clienteUsuarioVinculado.id;
                }

                const jsonVendedor = JSON.parse(localStorage.getItem('vendedor'));
                var vendedorID = jsonVendedor.codeVendedor;

                let usr = {
                    id : idClientUser,
                    customerId : userData.idCliente,
                    login : userData.login         
                }
                
                let dados = {
                    item: prod,
                    usr: usr
                }

                this.$awn.async(axios.post(`${ baseApiUrl }/orders/postVendedor/${vendedorID}`, dados,  data),
                resp => {
                    if(resp.data.valid){
                        this.$awn.success(resp.data.message, {labels: {success: resp.data.title }})
                        this.$modal.hide(this.idModal);
                    }
                    else{
                        this.$awn.warning(resp.data.message, {labels: {warning: resp.data.title }})
                        this.quantity = resp.data.quantity
                    }

                },
                err => this.$awn.alert(`API responded with code: ${err.response.status}`))
            } else {
                this.$awn.async(axios.post(`${ baseApiUrl }/orders`, prod, data),
                resp => {
                    if(resp.data.valid){
                        this.$awn.success(resp.data.message, {labels: {success: resp.data.title }})
                        this.$modal.hide(this.idModal);
                    }
                    else{
                        this.$awn.warning(resp.data.message, {labels: {warning: resp.data.title }})
                        this.quantity = resp.data.quantity
                    }

                },
                err => this.$awn.alert(`API responded with code: ${err.response.status}`))
            }           
        },
        inputAlterado(event){
            this.quantity = parseInt(event.target.value)
        },
        priceFormater(preco){
            return preco.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        ajustaURL(){
            if(this.urlDetail.match(/http:/) || this.urlDetail.match(/https:/)){
                return this.urlDetail
            }
            return 'http://'+this.urlDetail
        },
        openTab(){
            let win = null;
            if(this.urlDetail.match(/http:/) || this.urlDetail.match(/https:/)){
                win = window.open(this.urlDetail, 'tabdetalhes');
            }else{
                win = window.open('http://'+this.urlDetail, 'tabdetalhes');            
            }            
            win.focus();
        }
    }
}
</script>

<style scoped>
.indisponivel {
  background-color: gray!important;
}
/* modal */
.p-modal{
    display: flex;
    align-items: center;
}

img{
    animation: fadeIn 0.6s;
}

.fadeout{
    animation: fadeOut 0.6s;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
}

@keyframes fadeOut {
    from { 
        height: 125px;
        }
    to   { 
        height: 18px;
        }
}

.right{
    width: 190px;
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
header h2{
    margin-top: 0px;
    margin-bottom: 0px;
    color: white;
}

.input-quantity input{
    width: 100%;
    border: none;
    border-bottom: 1px solid #efefefc2;
    text-align: center;
    padding-bottom: 4px;
}

.modal-left{
    display: flex;
    border-right: 1px solid #adadad59;
    flex-grow: 1;
    align-items: center;
}
.image img{
    max-width: 80px;
    min-width: 80px;
}

.image{
    min-width: 80px;
}


.p-quantity{
    display: flex;
    justify-content: center;
    border: 1px solid #808080c2;
    padding: 4px;
    margin: 8px 4px 0px 4px;
}

.prices{
    display: flex;
    align-items: center;
}

.p-botoes{
    display: flex;
    margin: 10px;
    justify-content: center;
}

.desconto.qb-txt-md{
    margin-right: 16px;
}
.btn {
    height: auto;
    min-height: 40px;
    max-height: 80px;
}

.margin-left{
    margin-left: 16px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
    -moz-appearance:textfield;
}

.desconto{
    text-decoration:  line-through;
}
  .final{
    color: #B12704;
    font-weight: bold;
  }

  footer{
       background: rgb(32,176,169);
    background: linear-gradient(90deg, rgba(32,176,169,1) 0%, rgba(32,176,169,1) 55%, rgba(37,54,92,1) 100%); 
  }  
  .main-modal-close {
      float: right;
      visibility: hidden;
  }
  @media screen and (max-width: 520px){
      .main-modal-close {            
            visibility: visible;                    
        }
        .modal-left{
          flex-direction: column;
          align-items: center;
          border-right: none;
      }

      .p-modal{
        flex-direction: column;
      }

      .title{
          text-align: center;
      }

      .prices{
          justify-content: center;
      }
  }

  .codigo-produto{
      font-size: 12px;
      font-weight: 100;
      color: gray;
  }

  .qb-main-body-card{
      max-width: 630px;
  }
</style>
